var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.54 7.64L7.66 5.5m4.37 2.7l2.8 2.79c.33.34.3.91-.07 1.28l-2.2 2.2c-.36.37-.94.4-1.27.05l-2.8-2.79-1.9-1.9s-2.09.74-3.88-1.06C.49 6.58 2 3.83 2 3.83l2.12 2.12 2.12-2.12-2.12-2.12S6.9.25 9.07 2.4c1.91 1.91 1.06 3.9 1.06 3.9l1.9 1.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' d='M5.54 7.64L7.66 5.5m4.37 2.7l2.8 2.79c.33.34.3.91-.07 1.28l-2.2 2.2c-.36.37-.94.4-1.27.05l-2.8-2.79-1.9-1.9s-2.09.74-3.88-1.06C.49 6.58 2 3.83 2 3.83l2.12 2.12 2.12-2.12-2.12-2.12S6.9.25 9.07 2.4c1.91 1.91 1.06 3.9 1.06 3.9l1.9 1.9z'/%3E%3C/svg%3E";
export { ForwardRef as ReactComponent };